import React from 'react';
import MainSection from './MainSection';
import ProjectStats from './ProjectStats';
import Features from './Features';
import Roadmap from './Roadmap';
import Community from './Community';

const Home = () => {
  return (
    <>
      <MainSection />
      {/*<ProjectStats />*/}
      <Features />
      {/*<Roadmap />*/}
      <Community />
    </>
  );
};

export default Home;